import { Form, Button } from 'react-bootstrap';

const AddSchool = ({ moduleBank }) => {

    return (
        <div className="jumbotron mt-3 pt-3 pb-3">

            <div className="row">
                <div className="col">
                    <Form.Group controlId='serviceName'>
                        <Form.Label>School/Organization Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="school_name"
                            required
                            placeholder='name of school or organization'


                        />
                        <Form.Control.Feedback type="invalid">
                            Please enter full name
                        </Form.Control.Feedback>
                    </Form.Group>
                </div>

                <div className="col-md-2">

                    <Form.Group controlId='enrollment'>
                        <Form.Label>Enrollment</Form.Label>
                        <Form.Control
                            type="text"
                            pattern="[1-9]*"
                            name="enrollment"
                            required
                            placeholder='annual enrollment'
                            value={'' | null}

                        />
                    </Form.Group>
                </div>

            </div>
            <div className="mb-auto p-2"></div>
            <div className="row">
                <Button
                    type="submit"
                    className="btn btn-primary btn-block"
                    disabled={false}
                >Add to Cart
                </Button>

            </div>
            <div className="lead">
                Note: Please select another service from the service list.
            </div>
        </div>


    )
}

export { AddSchool };